import { Component, OnInit, OnDestroy, Input, AfterViewInit, ViewChild, ElementRef, EventEmitter, Output, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { UserLogin } from '../../models/user-login.model';
import { ICD, MasterConfig, ResponseAPI, ErrorList, ICDStep3 } from '../../models/IDPReport.model';
import { SfDataService } from '../../services/sf-data.service';
import { AgentService, PreSubmitIssue } from '../../services/agent.service';
import { AiHintStateService } from '../../services/ai-hint-state.service';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Utilities } from '../../services/utilities';
import Swal from 'sweetalert2';


import { environment } from './../../../environments/environment';



declare global {
  interface JQuery {
    datepicker(options?: any): any;
  }
}

interface JQuery<TElement = HTMLElement> {
  select2(options?: any): any;
}

interface JQuery {
  select2(options?: any): any;
}


// import custom validator to validate 
import { MustMatch } from '../../models/MustMatch';
import { dateNotLessThanTodayValidator } from '../../models/dateNotLessThanTodayValidator';
import { elevenDigitPhoneNumberValidator, tenDigitPhoneNumberValidator } from '../../phone-number-mask.directive';
import { postalCodeValidator } from '../../models/postalCodeValidator';


@Component({
    selector: 'app-sf-icd-addlocation',
    templateUrl: './sf-icd-addlocation.component.html',
    styleUrls: ['./sf-icd-addlocation.component.scss'],
    standalone: false
})

export class SfIcdAddlocationComponent implements OnInit, AfterViewInit {
  icd = new ICDStep3();
  data = {
    name: 'John',
    age: 30
  };

  userLogin = new UserLogin(); id: string; q: string; fm: string; d: string; idn: string;
  isLoading = false;
  isTestCampaign = false;
  isNew_DBA_Name = false;
  formResetToggle = true;
  modalClosedCallback: () => void;
  loginStatusSubscription: any;
  selectedCountry: string;
  isLocation_out_state = false;
  selected_WC_details: string
  icdForm: FormGroup;
  section1Form: FormGroup;
  section2Form: FormGroup;
  section3Form: FormGroup;
  section4Form: FormGroup;
  section5Form: FormGroup;
  section6Form: FormGroup;
  isInsuranceRequired: string;
  @Input()
  isModal = false;
  submitted = false;
  ddlUSStates = [];
  ddlBest_Delivery_Time = [];
  ddlCAProvinence = [];

  Canada_campaignData = [];
  Canada_campaignData_DD = [];
  Canada_retailsData = [];

  PO_namesData = [];
  NC_namesData = [];
  RC_namesData = [];


  US_campaignData = [];
  US_campaignData_DD = [];
  US_retailsData = [];
  icd_o = new ICD();
  @Output() dataEmitter = new EventEmitter<any>();
  @Input() inputData: any;
  selectedFiles: FileList;
  validFiles: File[] = [];
  fileData: { attachment_FileName: string, attachment_Base64: string, attachment_Type: string, FileId?: string, Url?: string, status?: 'uploading' | 'uploaded' | 'error' }[] = [];
  maxFilesAllowed: number = 15; // Maximum number of files allowed
  maxFileSize: number = 10 * 1024 * 1024; // 10 MB max file size (FR3)
  // Staged upload-on-select state, keyed by form control name.
  uploadState: { [controlName: string]: 'uploading' | 'uploaded' | 'error' } = {};
  uploadError: { [controlName: string]: string } = {};
  // Per-control selection counter so a slow FileReader from a superseded selection is ignored (FR2).
  private uploadSeq: { [controlName: string]: number } = {};

  US_Retails_selectedItems: any[] = [];
  US_Retails_isSelectedItemsinvalid = false;
  Canada_Retails_selectedItems: any[] = [];
  Canada_Retails_isSelectedItemsinvalid = false;
  US_Campaigns_selectedItems: any[] = [];
  US_Campaigns_isSelectedItemsinvalid = false;
  Canada_Campaigns_selectedItems: any[] = [];
  Canada_Campaigns_isSelectedItemsinvalid = false;

  isOTPValid = false;
  isCheckboxesDisabled = false;
  btnDisplay = true;
  // Pre-submit review
  showPreSubmitReview = false;
  preSubmitIssues: PreSubmitIssue[] = [];
  preSubmitLoading = false;
  verificationState: { [controlName: string]: 'pending' | 'verifying' | 'pass' | 'fail' | 'warn' } = {};
  verificationIssues: { [controlName: string]: string[] } = {};
  private readonly VERIFIED_DOC_TYPES: { [controlName: string]: string } = {
    Attach_Incorporation: 'ArticlesOfIncorporation',
    Attach_US_Certificate_of_Insurance: 'CertificateOfInsurance',
  };

  public masterConfig: MasterConfig[] = [];

  datad = {
    name: '',
    age: 0
  };

  @Output() idEmitter = new EventEmitter<string>();
  //@ViewChild('dobInput') dobInput: ElementRef;
  @ViewChild('datepicker') datepicker: ElementRef;
  @ViewChild('selectEl') selectEl: ElementRef;

  select2Options = {
    placeholder: 'Select an option...',
    width: '100%'
  };

  selectedOption: string;

  controlDisplayNames: { [key: string]: string } = {

    US_or_CA: 'Country',
    State_UI_ID: 'State UI ID',
    New_DBA_Name: 'New DBA Name',
    isPreferredDBA: 'Is this the ICD\'s Preferred DBA?',
    preferredDBAName: 'Preferred DBA Name',
    First_Date_New_Address: 'First Date At New Address',
    New_Address: 'New Address',
    Company_City: 'City',
    Company_Postal_Code: 'Postal Code',
    Company_Office_Phone: 'Office Phone',
    Company_Country: 'Country',
    Company_State: 'State',
    Company_Province: 'Province',
    Owner_Mobile_Phone: 'Owner Mobile Phone',
    Sales_tax_perc: 'Sales Tax Percentage',
    New_Location_out_state: 'New Location Out Of State',
    Is_storage_location: 'Storage Location',
    Main_or_Satellite: 'Main or Satellite Location',
    isInsuranceRequired: 'Insurance Required',

    Attach_Incorporation: 'Articles Of Incorporation',
    Attach_DBA_Doc: 'DBA Document',
    Attach_Renter_Insurance: 'Renter Insurance',
    Attach_US_Certificate_of_Insurance: 'Certificate Of Insurance',
    Workers_Compensation: 'Workers Compensation',
    TestCampaignNotListed: 'Campaign Name'
  };

  fieldMaxLengths: any = {
    Full_Legal_Company_Name: 255,
    Tax_ID: 25,
    State_UI_ID: 255,
    New_DBA_Name: 255,
    preferredDBAName: 255,
    ICD_Owner_Name: 150,
    New_Address: 250,
    Company_Address2: 150,
    Company_City: 150,
    Company_Postal_Code: 10,
    Company_Office_Phone: 40,
    Owner_Mobile_Phone: 40,
    HUB_Manager_Contact_Name: 150,
    Promoting_Owner: 150,
    Promoting_Owner_Company: 255,
    Regional_Consultant: 200,
    Regional_Consultant_Company: 200,
    National_Consultant: 200,
    National_Consultant_Company: 200,
    TestCampaignNotListed: 255,
    Male_Emp: 10,
    FeMale_Emp: 10,
    Company_Country: 100,
    Sales_tax_perc: 10
  };

  constructor(private route: ActivatedRoute, private elRef: ElementRef, private fb: FormBuilder, private router: Router, private alertService: AlertService, private authService: AuthService, private configurations: ConfigurationService, private sfDataService: SfDataService, private agentService: AgentService, private hintStateService: AiHintStateService) { }

  @Output() activateTab = new EventEmitter<number>();

  ngOnInit(): void {


    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Attempting login...');
    //this.emitActivateTab(3);
    $('.detailchild').removeClass('active');
    $('.detailmain').removeClass('active');
    $('#custom-tabs-four-more-tab').addClass('active');

    $('.detailchild').removeClass('tabhighlight'); 
    $('#custom-tabs-add-loc').addClass('tabhighlight');    
    $('#custom-tabs-four-more-tab').parent().addClass('active');

    this.id = this.route.snapshot.paramMap.get('id');

    this.fm = this.route.snapshot.paramMap.get('f');

    this.d = this.route.snapshot.paramMap.get('dcode');

    this.datad = this.inputData;
    this.CreateForm();

    this.BindDropdowns();
     
        this.idEmitter.emit(this.id);
        this.BindData(this.id);
       

  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: Event): void {
    event.preventDefault();
  }



  ShowSuccesspopup(str) {

    if (str == 'false') {
      Swal.fire({
        title: 'Data Saved Successfully!',
        icon: 'success',
        confirmButtonText: 'Back to Distributors ',
        showDenyButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        denyButtonText: ' Open HJ portal',
        showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
        preConfirm: async (val) => {
          if (val) {

          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          let url = '/icdreport/';
          this.router.navigate([url]);
        } else if (result.isDenied) {
          let urls = environment.hjPortalUrl + "/ICD_ACK/ICD_AddLoc.aspx?q=" + this.idn;
          // Open the URL in a new tab
          window.open(urls, '_blank');
          let url = '/icdreport/';
          this.router.navigate([url]);
        }
      });
    }
    else {
      Swal.fire({
        title: 'Data Saved Successfully!',
        icon: 'success',
        confirmButtonText: 'Back to Distributors ',
        showDenyButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        denyButtonText: ' Open HJ portal',
        showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
        preConfirm: async (val) => {
          if (val) {

          }
        },
      }).then((result) => {
        if (result.isConfirmed) {
          let url = '/icdreport/';
          this.router.navigate([url]);
        } else if (result.isDenied) {
          let urls = environment.hjPortalUrl + "/ICD_ACK/ICD_AddLoc.aspx?q=" + this.idn;
          // Open the URL in a new tab
          window.open(urls, '_blank');
          let url = '/icdreport/';
          this.router.navigate([url]);
        }
      });
    }
   
  }

  ShowOTPpopup(str: string) {
    Swal.fire({
      title: 'OTP!',
      text: str,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,
      input: 'text',
      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (!val) {
          Swal.showValidationMessage("OTP is required");
        } else {
          try {

            // Create a new instance of the ICD class
            let responseAPI = new ResponseAPI();
            this.sfDataService.getOTP(this.id, val, this.q)
              .subscribe(
                data => {

                  //responseAPI = data;
                  // Assign the received data to the responseAPI object
                  responseAPI = data;
                  if (responseAPI.isSuccess) {
                    this.isOTPValid = responseAPI.isSuccess;
                    this.idEmitter.emit(this.id);
                    this.BindData(this.id);
                  }
                  else {
                    // API call failed, reject the Promise to prevent closing the popup
                    this.ShowOTPpopup("Wrong Access Code, Enter Access Code to continue");
                  }

                },
                error => {

                  this.alertService.stopLoadingMessage();

                  if (Utilities.checkNoNetwork(error)) {
                    this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
                    this.offerAlternateHost();
                  } else {
                    const errorMessage = Utilities.getHttpResponseMessage(error);

                    if (errorMessage) {
                      this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
                    } else {
                      this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
                    }
                  }

                  setTimeout(() => {
                    this.isLoading = false;
                  }, 500);
                });

            // await this.apiService.postData(val);
            // API call succeeded, resolve the Promise
          } catch (error) {
            // API call failed, reject the Promise to prevent closing the popup
            return Promise.reject(error);
          }
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle success case when the API call is successful
      } else if (result.isDenied) {
        // Handle the case when the user cancels the dialog
      } else if (result.isDismissed) {
        // Handle the case when the dialog is closed without confirmation
      }
    });
  } 

  CreateForm() {
    this.icdForm = this.fb.group({
      US_or_CA: ['', Validators.required],
      Full_Legal_Company_Name: [{ value: '', disabled: true }],
      Tax_ID: [{ value: '', disabled: true }],
      State_UI_ID: ['', [Validators.maxLength(this.fieldMaxLengths.State_UI_ID), this.noHtmlTagsValidator.bind(this)]],

      New_DBA_Name: ['', [Validators.maxLength(this.fieldMaxLengths.New_DBA_Name) , this.noHtmlTagsValidator.bind(this)]],
      isNew_DBA_Name: [''],
      isPreferredDBA: [''],                    
      preferredDBAName: [''],                 
      
      First_Date_New_Address: ['', [Validators.required,Validators.pattern(/^(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])\-\d{4}$/)]],

      ICD_Owner_Name: [{ value: '', disabled: true }],
      New_Address: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.New_Address), this.noHtmlTagsValidator.bind(this)]],
      Company_Address2: ['', [Validators.maxLength(this.fieldMaxLengths.Company_Address2) ,this.noHtmlTagsValidator.bind(this)]],
      Company_City: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_City) ,this.noHtmlTagsValidator.bind(this)]],
      Company_Postal_Code: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_Postal_Code), this.noHtmlTagsValidator.bind(this), postalCodeValidator()]],
      Company_Office_Phone: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_Office_Phone), tenDigitPhoneNumberValidator()]],
      
      Company_Country: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_Country)]],
      Company_State: ['', Validators.required],
      Company_Province: ['', Validators.required],
      Owner_Mobile_Phone: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Mobile_Phone), elevenDigitPhoneNumberValidator()]],

      Sales_tax_perc: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Sales_tax_perc)]],
      New_Location_out_state: ['', Validators.required],
      Is_storage_location: ['', Validators.required],
      Main_or_Satellite: ['', Validators.required],
       
      isInsuranceRequired: ['', Validators.required],
      HUB_Manager_Contact_Name: [{ value: '', disabled: true }],
       

      Promoting_Owner: [{ value: '', disabled: true }],
      Promoting_Owner_Company: [{ value: '', disabled: true }],
      Regional_Consultant: [{ value: '', disabled: true }],
      Regional_Consultant_Company: [{ value: '', disabled: true }],
      National_Consultant: [{ value: '', disabled: true }],
      National_Consultant_Company: [{ value: '', disabled: true }],

      Node_Form: [''],
      Extra_Provincial_License: [''],

      Attach_Incorporation: ['', []],
      Attach_DBA_Doc: ['', []],
      Attach_Renter_Insurance: ['', []],

      Attach_US_Certificate_of_Insurance: ['', []],
      Workers_Compensation: ['', []],
      TestCampaignNotListed: ['', [Validators.maxLength(this.fieldMaxLengths.TestCampaignNotListed) ,this.noHtmlTagsValidator.bind(this)]],
      //Quebec_Power_of_Attorney: ['', []],
      Male_Emp: ['', [Validators.maxLength(this.fieldMaxLengths.Male_Emp) ,this.noHtmlTagsValidator.bind(this)]],
      FeMale_Emp: ['', [Validators.maxLength(this.fieldMaxLengths.FeMale_Emp) ,this.noHtmlTagsValidator.bind(this)]],
      Disability_Form: [''],

    });
     

  }


  onChangeisNewDBA() {
    const US_or_CA = this.icdForm.get('isNew_DBA_Name').value;
    if (US_or_CA == true) {
      this.isNew_DBA_Name = true;
      this.icdForm.get('New_DBA_Name').setValidators([Validators.required, Validators.maxLength(this.fieldMaxLengths.New_DBA_Name), this.noHtmlTagsValidator.bind(this)]);
      this.icdForm.get('Attach_DBA_Doc').setValidators([Validators.required]);

      this.icdForm.get('Attach_DBA_Doc').setValue(null);

    } else {
      this.isNew_DBA_Name = false;
      this.icdForm.get('New_DBA_Name').clearValidators();
      this.icdForm.get('Attach_DBA_Doc').clearValidators();

    }

    this.icdForm.get('New_DBA_Name').updateValueAndValidity();
    this.icdForm.get('Attach_DBA_Doc').updateValueAndValidity();



    }


    onChangePreferredDBA() {
        const isPreferred = this.icdForm.get('isPreferredDBA').value;
        const preferredNameControl = this.icdForm.get('preferredDBAName');

        if (isPreferred === 'No') {
            // If "No", make preferredDBAName required
            preferredNameControl.setValidators([
                Validators.required,
                Validators.maxLength(255),
                this.noHtmlTagsValidator.bind(this)
            ]);
        } else {
            // If "Yes" or empty, clear validators
            preferredNameControl.clearValidators();
        }

        preferredNameControl.updateValueAndValidity();
    }

  onStateChange(event: any): void {
    const selectedState = event; // The selected state value
    const stateUIControl = this.icdForm.get('State_UI_ID');

    if (['CO', 'FL', 'MN', 'NY'].includes(selectedState)) {
      this.icdForm.get('State_UI_ID').setValidators([Validators.required, Validators.maxLength(this.fieldMaxLengths.State_UI_ID), this.noHtmlTagsValidator.bind(this)]);
    } else {
      this.icdForm.get('State_UI_ID').clearValidators();
    }

    this.icdForm.get('State_UI_ID').updateValueAndValidity();
  }

  ChangeIsInsurance() {

    this.isInsuranceRequired = this.icdForm.get('isInsuranceRequired').value;
    if (this.isInsuranceRequired === 'false') {

      
      this.icdForm.get('Attach_US_Certificate_of_Insurance').setValidators([Validators.required]);
      this.icdForm.get('Workers_Compensation').setValidators([Validators.required]);

    } else {

      this.icdForm.get('Attach_US_Certificate_of_Insurance').clearValidators();
      this.icdForm.get('Workers_Compensation').clearValidators();
    }

    
    
    this.icdForm.get('Attach_US_Certificate_of_Insurance').updateValueAndValidity();
    this.icdForm.get('Workers_Compensation').updateValueAndValidity();

  }
  sendDataToParent() {
    this.dataEmitter.emit(this.datad);
  }
  // convenience getter for easy access to form fields
  get f() { return this.icdForm.controls; }

  get s1() { return this.section1Form.controls; }

  get items(): FormArray {
    return this.icdForm.get('items') as FormArray;
  }



  onCountryChange() {
    const US_or_CA = this.icdForm.get('US_or_CA').value;
    if (US_or_CA === 'US') {
      this.selectedCountry = "US";
     
      this.icdForm.get('Company_Country').setValidators([Validators.required]);
      this.icdForm.get('Company_State').setValidators([Validators.required]);
      this.icdForm.get('Company_Province').clearValidators(); 
    } else {
      this.selectedCountry = "Canada";
      
       

      this.icdForm.get('Company_Country').clearValidators();
      this.icdForm.get('Company_State').clearValidators();
      this.icdForm.get('Company_Province').setValidators([Validators.required]);
       

    } 

     
    this.icdForm.get('Company_Country').updateValueAndValidity();
    this.icdForm.get('Company_State').updateValueAndValidity();
    this.icdForm.get('Company_Province').updateValueAndValidity();

     
     
  }

  onChange_outofState(event: any) {
    if (event.target.value == "true") {

      this.isLocation_out_state = true;
      this.icdForm.get('Attach_Incorporation').setValidators([Validators.required]);
      //this.icdForm.get('Attach_US_Certificate_of_Insurance').setValidators([Validators.required]);
    } else {
      
      this.isLocation_out_state = false;
      //this.icdForm.get('Attach_US_Certificate_of_Insurance').clearValidators();
      this.icdForm.get('Attach_Incorporation').clearValidators();
    }
     
    //this.icdForm.get('Attach_US_Certificate_of_Insurance').updateValueAndValidity();
    this.icdForm.get('Attach_Incorporation').updateValueAndValidity();

  }
  onCheckboxChange_US_Retails(event: any, value: any) {
    if (event.target.checked) {
      this.US_Retails_selectedItems.push(value);
    } else {
      const index = this.US_Retails_selectedItems.indexOf(value);
      if (index > -1) {
        this.US_Retails_selectedItems.splice(index, 1);
      }
    }


    if (this.US_Retails_selectedItems.length <= 0) {
      this.US_Retails_isSelectedItemsinvalid = true;
    }
    else {
      this.US_Retails_isSelectedItemsinvalid = false;
    }


  }


  onCheckboxChange_Canada_Retails(event: any, value: any) {
    if (event.target.checked) {
      this.Canada_Retails_selectedItems.push(value);
    } else {
      const index = this.Canada_Retails_selectedItems.indexOf(value);
      if (index > -1) {
        this.Canada_Retails_selectedItems.splice(index, 1);
      }
    }


    if (this.Canada_Retails_selectedItems.length <= 0) {
      this.Canada_Retails_isSelectedItemsinvalid = true;
    }
    else {
      this.Canada_Retails_isSelectedItemsinvalid = false;
    }


  }


  Showsuccesspopup1(str: string) {
    Swal.fire({
      title: str,
      icon: 'error',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {

          //location.reload();
        }
      },
    }).then((result) => {

    });
  }


  onCheckboxChange_US_Campaigns(event: any, value: any) {

    if (event.target.checked) {



      let dueDiligence = this.US_campaignData_DD.filter(a => a.dueDiligenceRequired == "Yes" && a.campaignName == value);;

      if (dueDiligence.length > 0) {

        
        let ownername = this.icd.Owner_First_Name + " " + this.icd.Owner_Last_Name;
        if (this.icd.Owner_Preferred_First_Name != null && this.icd.Owner_Preferred_Last_Name != null) {
          ownername = this.icd.Owner_Preferred_First_Name + " " + this.icd.Owner_Preferred_Last_Name;
        }
        this.sfDataService.CheckDueDeligRequiredMyOwnOffice(this.icd.PromotingOwner, value, ownername).subscribe(resp => {
          ////console.log(resp);

          const filtered = this.filterRecentRecords(resp, 90);
          ////console.log('raw resp', resp);
          ////console.log('filtered resp (90 days)', filtered);


          if (filtered.length <= 0) {

            this.alertService.showMessage('Cannot select this campaign, as it requires due diligence.', '.', MessageSeverity.error);
            this.Showsuccesspopup1('Cannot select this campaign, as it requires due diligence.');
            // Uncheck the checkbox
            event.target.checked = false;
            return;
          }

          if (value == "TestCampaign(NotListed)") {
            this.isTestCampaign = true;
            this.icdForm.get('TestCampaignNotListed').setValidators([Validators.required, Validators.maxLength(this.fieldMaxLengths.TestCampaignNotListed), this.noHtmlTagsValidator.bind(this)]);
            this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();

          }
          this.US_Campaigns_selectedItems.push(value);
        });

      }
      else {
        if (value == "TestCampaign(NotListed)") {
          this.isTestCampaign = true;
          this.icdForm.get('TestCampaignNotListed').setValidators([Validators.required, Validators.maxLength(this.fieldMaxLengths.TestCampaignNotListed), this.noHtmlTagsValidator.bind(this)]);
          this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();

        }
        this.US_Campaigns_selectedItems.push(value);
      }


    }
    else {
      this.isTestCampaign = false;
      this.icdForm.get('Company_Country').clearValidators();
      this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();
      const index = this.US_Campaigns_selectedItems.indexOf(value);
      if (index > -1) {
        this.US_Campaigns_selectedItems.splice(index, 1);
      }
    }


    if (this.US_Campaigns_selectedItems.length <= 0) {
      this.US_Campaigns_isSelectedItemsinvalid = true;
    }
    else {
      this.US_Campaigns_isSelectedItemsinvalid = false;
    }


  }



  onCheckboxChange_Canada_Campaigns(event: any, value: any) {
    if (event.target.checked) {




      let dueDiligence = this.Canada_campaignData_DD.filter(a => a.dueDiligenceRequired == "Yes" && a.campaignName == value);;

      if (dueDiligence.length > 0) {

        let ownername = this.icd.Owner_First_Name + " " + this.icd.Owner_Last_Name;
        if (this.icd.Owner_Preferred_First_Name != null && this.icd.Owner_Preferred_Last_Name != null) {
          ownername = this.icd.Owner_Preferred_First_Name + " " + this.icd.Owner_Preferred_Last_Name;
        }
        this.sfDataService.CheckDueDeligRequiredMyOwnOffice(this.icd.PromotingOwner, value, ownername).subscribe(resp => {

          const filtered = this.filterRecentRecords(resp, 90);
          ////console.log('raw resp', resp);
          ////console.log('filtered resp (90 days)', filtered);


          if (filtered.length <= 0) {

            this.alertService.showMessage('Cannot select this campaign, as it requires due diligence.', '.', MessageSeverity.error);
            this.Showsuccesspopup1('Cannot select this campaign, as it requires due diligence.');
            // Uncheck the checkbox
            event.target.checked = false;
            return;
          }

          if (value == "TestCampaign(NotListed)") {
            this.isTestCampaign = true;
            this.icdForm.get('TestCampaignNotListed').setValidators([Validators.required, Validators.maxLength(this.fieldMaxLengths.TestCampaignNotListed), this.noHtmlTagsValidator.bind(this)]);
            this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();

          }
          this.Canada_Campaigns_selectedItems.push(value);
        });

      }
      else {
        if (value == "TestCampaign(NotListed)") {
          this.isTestCampaign = true;
          this.icdForm.get('TestCampaignNotListed').setValidators([Validators.required, Validators.maxLength(this.fieldMaxLengths.TestCampaignNotListed), this.noHtmlTagsValidator.bind(this)]);
          this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();

        }
        this.Canada_Campaigns_selectedItems.push(value);
      }




    } else {
      const index = this.Canada_Campaigns_selectedItems.indexOf(value);
      if (index > -1) {
        this.Canada_Campaigns_selectedItems.splice(index, 1);
      }
    }


    if (this.Canada_Campaigns_selectedItems.length <= 0) {
      this.Canada_Campaigns_isSelectedItemsinvalid = true;
    }
    else {
      this.Canada_Campaigns_isSelectedItemsinvalid = false;
    }


  }


  showErrorAlert(caption: string, message: string) {
    this.alertService.showMessage(caption, message, MessageSeverity.error);
  }

  // Front-end displays dates as MM-DD-YYYY; Salesforce stores them as YYYY-MM-DD.
  // Convert a UI MM-DD-YYYY value to YYYY-MM-DD before saving. Idempotent/safe for
  // empty or already-normalized values.
  private toSfDate(v: string): string {
    if (!v) { return v; }
    const m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(v.trim());
    return m ? `${m[3]}-${m[1]}-${m[2]}` : v;
  }

  // Convert a Salesforce YYYY-MM-DD (optionally with a time component) to the
  // MM-DD-YYYY the datepicker/UI expects. Safe for empty/invalid values.
  private toDisplayDate(v: string): string {
    if (!v) { return v; }
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v.trim());
    return m ? `${m[2]}-${m[3]}-${m[1]}` : v;
  }

  ngAfterViewInit() {

     $('#First_Date_New_Address').datepicker({
      dateFormat: 'mm-dd-yy',
      changeMonth: true,
      changeYear: true,
      // minDate: 0,
      onSelect: (dateText, inst) => {
        this.datepicker = dateText;
        this.icdForm.controls['First_Date_New_Address'].patchValue(dateText);
        this.icdForm.controls['First_Date_New_Address'].markAsTouched();
        this.icdForm.controls['First_Date_New_Address'].updateValueAndValidity();
      }
    });

    //if (this.selectEl) {
    //  $(this.selectEl.nativeElement).select2({ width: '100%' });
    //};

    //setTimeout(() => {
    //  $('.select2', this.elRef.nativeElement).select2();
    //}, 0);
    //$('.select2').select();
    //$(this.datepicker.nativeElement).datepicker({
    //  dateFormat: 'yyyy-mm-dd',
    //  autoclose: true,
    //  onSelect: (date) => {
    //    this.dobInput.nativeElement.value = date;
    //  }
    //});

    //$('.select2').select2(); //initialize 
  }

  closeModal() {
    if (this.modalClosedCallback) {
      this.modalClosedCallback();
    }
  }

  onSubmit() {
    this.hintStateService.collapse();

    this.submitted = true;

    // FR1: do not submit while a file is still uploading to staging.
    if (this.hasUploadsInFlight()) {
      this.alertService.showMessage('Please wait', 'A file is still uploading. Please wait until it finishes before submitting.', MessageSeverity.error);
      this.Showsuccesspopup1('A file is still uploading. Please wait until it finishes before submitting.');
      return;
    }

    this.trimFormValues();
    if (this.selectedCountry === 'US') {

      if (this.US_Campaigns_selectedItems.length <= 0) {
        this.US_Campaigns_isSelectedItemsinvalid = true;
      }
      else {
        this.US_Campaigns_isSelectedItemsinvalid = false;
      }


      //if (this.US_Retails_selectedItems.length <= 0) {
      //  this.US_Retails_isSelectedItemsinvalid = true;
      //}
      //else {
      //  this.US_Retails_isSelectedItemsinvalid = false;
      //}


    }
    else {

      if (this.Canada_Campaigns_selectedItems.length <= 0) {
        this.Canada_Campaigns_isSelectedItemsinvalid = true;
      }
      else {
        this.Canada_Campaigns_isSelectedItemsinvalid = false;
      }


      //if (this.Canada_Retails_selectedItems.length <= 0) {
      //  this.Canada_Retails_isSelectedItemsinvalid = true;
      //}
      //else {
      //  this.Canada_Retails_isSelectedItemsinvalid = false;
      //}


    }

    //const allContainAssurance = this.US_Campaigns_selectedItems.some(value => value.toLowerCase().includes("assurance"));

    //if (allContainAssurance && this.US_Campaigns_selectedItems.length > 0) {
    //  this.icdForm.get('Node_Form').setValidators([Validators.required]);
    //  this.icdForm.get('Node_Form').updateValueAndValidity();
      
    //} else {
    //  this.icdForm.get('Node_Form').clearValidators();
    //  this.icdForm.get('Node_Form').updateValueAndValidity();
      
    //}

    if (this.isLocation_out_state) {
      this.icdForm.get('Attach_Incorporation').setValidators([Validators.required]);
      this.icdForm.get('Attach_Incorporation').updateValueAndValidity();
    }
    else {

      this.icdForm.get('Attach_Incorporation').clearValidators();
      this.icdForm.get('Attach_Incorporation').updateValueAndValidity();
    }


    this.icdForm.get('Disability_Form').clearValidators();
    this.icdForm.get('Male_Emp').clearValidators();
    this.icdForm.get('FeMale_Emp').clearValidators();

    this.icdForm.get('Male_Emp').updateValueAndValidity();
    this.icdForm.get('FeMale_Emp').updateValueAndValidity();
    this.icdForm.get('Disability_Form').updateValueAndValidity();

    const State_of_Incorporation = this.icdForm.get('Company_State').value;

    const Company_Province = this.icdForm.get('Company_Province').value;


    //if (Company_Province === 'QC') {
    //  this.icdForm.get('Quebec_Power_of_Attorney').setValidators([Validators.required]);
    //  let Quebec_Power_of_Attorney = this.icdForm.get('Quebec_Power_of_Attorney').value;
    //  if (Quebec_Power_of_Attorney == null) {
    //    this.alertService.showMessage('ICD', `Quebec Power of Attorney is mandatory.`, MessageSeverity.error);
    //      return;
    //    }
    //}
    //else {

    //  this.icdForm.get('Quebec_Power_of_Attorney').clearValidators();
    //}
    //this.icdForm.get('Quebec_Power_of_Attorney').updateValueAndValidity();

    if (State_of_Incorporation === 'NY' || State_of_Incorporation === 'HI') {

      if (this.isInsuranceRequired === 'false') {

        //this.icdForm.get('Disability_Form').setValidators([Validators.required]);
        //this.icdForm.get('Male_Emp').clearValidators();
        //this.icdForm.get('FeMale_Emp').clearValidators();
        //let Disability_Form = this.icdForm.get('Disability_Form').value;
        //this.icdForm.get('Male_Emp').updateValueAndValidity();
        //this.icdForm.get('FeMale_Emp').updateValueAndValidity();
        //this.icdForm.get('Disability_Form').updateValueAndValidity();
        //if (Disability_Form == null) {
        //  this.alertService.showMessage('ICD', `Disability Form is mandatory.`, MessageSeverity.error);
        //  return;
        //}
        //this.icdForm.get('Attach_Workers_Compensation').setValidators([Validators.required]);




      } else {
        //this.icdForm.get('Disability_Form').clearValidators();
        //this.icdForm.get('Male_Emp').setValidators([Validators.required]);
        //this.icdForm.get('FeMale_Emp').setValidators([Validators.required]);
        //let Male_Emp = this.icdForm.get('Male_Emp').value;
        //let FeMale_Emp = this.icdForm.get('FeMale_Emp').value;

        //this.icdForm.get('Male_Emp').updateValueAndValidity();
        //this.icdForm.get('FeMale_Emp').updateValueAndValidity();
        //this.icdForm.get('Disability_Form').updateValueAndValidity();
        //if (Male_Emp == null || FeMale_Emp == null) {
        //  this.alertService.showMessage('ICD', `# of Male & Female Employees fields are mandatory.`, MessageSeverity.error);
        //  return;
        //}
        //this.icdForm.get('Attach_Workers_Compensation').clearValidators();



      }


      
    }

    if ((this.selectedCountry === 'US' && (this.US_Campaigns_isSelectedItemsinvalid)) ||
      (this.selectedCountry !== 'US' && (this.Canada_Campaigns_isSelectedItemsinvalid))) {



      // Mark all fields as touched to display validation errors
      this.icdForm.markAllAsTouched();
      //this.alertService.showMessage('Enter Mandatory fields', commaSeparated, MessageSeverity.error);
      this.alertService.showMessage('at least select one option in Campaigns', '', MessageSeverity.error);
      this.Showsuccesspopup1('at least select one option in Campaigns');
      // Mark all fields as touched to display validation errors
      this.icdForm.markAllAsTouched();

      return;
    }

    // Check if Campaigns, Retailers, and form are invalid
    if ((this.selectedCountry === 'US' && (this.US_Campaigns_isSelectedItemsinvalid)) ||
      (this.selectedCountry !== 'US' && (this.Canada_Campaigns_isSelectedItemsinvalid)) ||
      this.icdForm.invalid) {

      const formControls = this.icdForm.controls;

      // Initialize an array to store invalid controls
      const invalidControls: string[] = [];

      
      // Iterate through the form controls and check if they are invalid
      Object.keys(formControls).forEach(controlName => {
        const control = this.icdForm.get(controlName);

        if (control?.invalid) {
          let displayName =
            this.controlDisplayNames[controlName] || controlName;

          if (control.errors?.invalidHtml) {
            displayName += ' (HTML/script not allowed)';
          }
          invalidControls.push(displayName);
        }
      });

      // Now, the 'invalidControls' array contains the names of all invalid form controls
      ////console.log('Invalid controls:', invalidControls);
      const commaSeparated = invalidControls.join(', ');

      // Mark all fields as touched to display validation errors
      this.icdForm.markAllAsTouched();
      this.alertService.showMessage('Enter required fields', commaSeparated, MessageSeverity.error);
      this.Showsuccesspopup1('Enter required fields :' + commaSeparated);
      return;
    }

     

    this.showPreSubmitReview = true;
    this.runPreSubmitReview();

  }

  fileValidator(control: any) {
    const files = control.value;

    if (!files || files.length === 0) {
      return null;
    }
    if (files.length + this.fileData.length > this.maxFilesAllowed) {
      return { maxFilesExceeded: true };
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!this.isValidFileFormat(file)) {
        return { invalidFormat: true };
      }

      if (file.size > this.maxFileSize) {
        return { fileSizeExceeded: true };
      }
    }

    return null;
  }

  //onFileSelected(event: any, inputId: string) {

  //  const files = event.target.files;


  //  for (let i = 0; i < files.length; i++) {
  //    const file = files[i];

  //    if (!this.isValidFileFormat(file)) {
  //      //console.log('Invalid file format:', file.name);
  //      this.icdForm.get('Attach_US_Articles_of_Incorporation').setErrors({ invalidFormat: true });

  //      continue;
  //    }

  //    const reader = new FileReader();
  //    reader.readAsDataURL(file);

  //    reader.onload = () => {
  //      const base64 = reader.result.toString().split(',')[1];
  //      this.fileData.push({ name: file.name, base64 });

  //      // Update the 'Attach_1' form control with the selected file name
  //      this.icdForm.patchValue({ Attach_US_Articles_of_Incorporation: file.name });

  //    };
  //  }

  //  this.uploadFiles();
  //}

  //onFileSelected(event: any, controlName: string) {
  //  const files = event.target.files;
  //  const errorMessages: string[] = [];
  //  if (!files || files.length === 0) {
  //    // Remove files only for the specific control
  //    this.fileData = this.fileData.filter(file => file.attachment_Type !== controlName);
  //    this.icdForm.get(controlName).setErrors({ noFileSelected: true });
  //    return;
  //  }

  //  // Remove previously selected files for this control while keeping others
  //  this.fileData = this.fileData.filter(file => file.attachment_Type !== controlName);


  //  const errors = [];

  //  for (let i = 0; i < files.length; i++) {
  //    const file = files[i];

  //    if (!this.isValidFileFormat(file)) {
  //      errorMessages.push(`Invalid file format for file "${file.name}". Allowed formats: pdf, jpg, jpeg, png, xls, xlsx.`);

  //      //console.log('Invalid file format:', file.name);
  //      errors.push({ invalidFormat: true });
  //    }

  //    if (file.size > this.maxFileSize) {
  //      errorMessages.push(`File size exceeds 25 MB limit for file "${file.name}".`);

  //      //console.log('File size exceeds the limit:', file.name);
  //      errors.push({ fileSizeExceeded: true });
  //    }
  //  }

  //  if (errors.length > 0) {
  //    const combinedMessage = errorMessages.join('\n');

  //    this.alertService.showMessage(combinedMessage, '.', MessageSeverity.error);
  //    this.Showsuccesspopup1(combinedMessage);
  //    this.icdForm.get(controlName).setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
  //    setTimeout(() => {
  //      event.target.value = '';
  //    });
  //  } else {
  //    for (let i = 0; i < files.length; i++) {
  //      const file = files[i];

  //      const reader = new FileReader();
  //      reader.readAsDataURL(file);

  //      reader.onload = () => {
  //        const b64 = reader.result.toString().split(',')[1];
  //        this.fileData.push({ attachment_FileName: file.name, attachment_Base64: b64, attachment_Type: controlName });
  //      };
  //    }

  //    this.icdForm.get(controlName).setErrors(null);
  //  }
  //}

  onFileSelected(event: any, controlName: string) {
    const files: FileList = event.target.files;
    const control = this.icdForm.get(controlName);
    const errorMessages: string[] = [];

    // Remove existing files for this control
    this.fileData = this.fileData.filter(
      f => f.attachment_Type !== controlName
    );

    // ---------- NO FILE SELECTED ----------
    if (!files || files.length === 0) {
      const hasRequired = control?.hasValidator?.(Validators.required);

      if (hasRequired) {
        control?.setErrors({ required: true });
      } else {
        control?.setErrors(null);
      }

      control?.markAsTouched();
      control?.updateValueAndValidity();
      return;
    }

    // ---------- VALIDATE FILES ----------
    const errors: any = {};

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (!this.isValidFileFormat(file)) {
        errors.invalidFormat = true;
        errorMessages.push(
          `Invalid format: ${file.name}`
        );
      }

      if (file.size > this.maxFileSize) {
        errors.fileSizeExceeded = true;
        errorMessages.push(
          `File size exceeds limit: ${file.name}`
        );
      }
    }

    // ---------- VALIDATION FAILED ----------
    if (Object.keys(errors).length > 0) {
      this.alertService.showMessage(
        errorMessages.join('\n'),
        '.',
        MessageSeverity.error
      );

      this.Showsuccesspopup1(errorMessages.join('\n'));

      control?.setErrors(errors);

      setTimeout(() => {
        event.target.value = ''; // ONLY allowed value
      });

      return;
    }

    // ---------- SUCCESS: upload each file to staging on select (FR1) ----------
    this.uploadState[controlName] = 'uploading';
    this.uploadError[controlName] = '';
    const inputEl = event.target as HTMLInputElement;
    // Bump the selection counter; a superseded selection's FileReader result is discarded (FR2).
    const seq = this.uploadSeq[controlName] = (this.uploadSeq[controlName] || 0) + 1;

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = () => {
        if (this.uploadSeq[controlName] !== seq) { return; } // a newer selection superseded this one
        const b64 = reader.result!.toString().split(',')[1];
        const entry: { attachment_FileName: string, attachment_Base64: string, attachment_Type: string, FileId?: string, Url?: string, status?: 'uploading' | 'uploaded' | 'error' } = {
          attachment_FileName: file.name,
          attachment_Base64: b64,
          attachment_Type: controlName,
          status: 'uploading'
        };
        this.fileData.push(entry);
        this.triggerDocumentVerification(controlName);
        this.stageFile(entry, controlName, inputEl);
      };
    }

    control?.setErrors(null);
    control?.markAsTouched();
    control?.updateValueAndValidity();
  }

  // Uploads a single file to the staging area. A response from a previously replaced/cancelled
  // upload is ignored via object identity: if the entry is no longer in fileData, discard it (FR2).
  private stageFile(entry: any, controlName: string, inputEl: HTMLInputElement): void {
    const body = {
      CaseID: this.icd?.CaseID || '',
      Attachment_FileName: entry.attachment_FileName,
      Attachment_Base64: entry.attachment_Base64,
      Owner_Email: this.icdForm?.get('Owner_Email')?.value || this.icd?.Owner_Email || this.icdForm?.get('Company_Business_Email')?.value || this.icd?.Company_Business_Email || this.icdForm?.get('HUB_Manager_Contact_Email')?.value || this.icd?.HUB_Manager_Contact_Email || this.icd?.HUB_Assistance_Email || '',
      Owner_Name: ((this.icd?.Owner_First_Name || '') + ' ' + (this.icd?.Owner_Last_Name || '')).trim(),
      Tax_ID: this.icd?.Tax_ID || ''
    };

    entry.StagingUniqueId = body.CaseID;

    this.sfDataService.stageAttachment(body).subscribe({
      next: (res: any) => {
        if (!this.fileData.includes(entry)) { return; } // superseded by a newer selection (FR2)
        if (res && res.isSuccess) {
          entry.FileId = res.fileId;
          entry.Url = res.url;
          entry.status = 'uploaded';
        } else {
          entry.status = 'error';
          this.removeStagedEntry(entry, inputEl);
          this.uploadError[controlName] = (res && res.errorMessage) ? res.errorMessage : 'Upload failed — please re-select the file.';
        }
        this.recomputeUploadState(controlName);
      },
      error: (err: any) => {
        if (!this.fileData.includes(entry)) { return; }
        entry.status = 'error';
        this.removeStagedEntry(entry, inputEl);
        this.uploadError[controlName] = this.extractServerError(err);
        this.recomputeUploadState(controlName);
      }
    });
  }

  // FR5: a failed file must not be silently submitted — drop it and force a re-select.
  private removeStagedEntry(entry: any, inputEl: HTMLInputElement): void {
    this.fileData = this.fileData.filter(f => f !== entry);
    const control = this.icdForm.get(entry.attachment_Type);
    if (inputEl) { inputEl.value = ''; }
    if (control?.hasValidator?.(Validators.required)) {
      control.setErrors({ required: true });
    }
    control?.markAsTouched();
  }

  private recomputeUploadState(controlName: string): void {
    const entries = this.fileData.filter(f => f.attachment_Type === controlName);
    if (entries.some(e => e.status === 'uploading')) {
      this.uploadState[controlName] = 'uploading';
    } else if (entries.length > 0 && entries.every(e => e.status === 'uploaded')) {
      this.uploadState[controlName] = 'uploaded';
      this.uploadError[controlName] = '';
    } else if (entries.length === 0 && this.uploadError[controlName]) {
      this.uploadState[controlName] = 'error';
    } else if (entries.length === 0) {
      delete this.uploadState[controlName];
    }
  }

  private extractServerError(err: any): string {
    try {
      if (err?.error?.errorMessage) { return err.error.errorMessage; }
      if (typeof err?.error === 'string' && err.error) { return err.error; }
      if (err?.message) { return err.message; }
    } catch { /* ignore */ }
    return 'Upload failed — please re-select the file.';
  }

  // FR1: block submission while any staged upload is still resolving.
  hasUploadsInFlight(): boolean {
    return this.fileData.some(f => f.status === 'uploading');
  }



  isInvalid(controlName: string): boolean {
    const control = this.icdForm.get(controlName);
    return control.touched && control.invalid;
  }


  public openFile(name: string, type: string): void {
    this.getBase64DownloadUrl(name, type).then((url: string) => {
      window.open(url, '_blank');
    });
  }

  public getBase64DownloadUrl(name: string, type: string): Promise<string> {
    const file = this.fileData.find(f => f.attachment_FileName === name && f.attachment_Type === type);

    if (file) {
      const fileExtension = this.getFileExtension(name);
      const mimeType = this.getMimeType(fileExtension);
      const base64Data = file.attachment_Base64;

      return Promise.resolve(`data:${mimeType};base64,${base64Data}`);
    } else {
      return Promise.reject(new Error('File not found.'));
    }
  }


  private getFileExtension(fileName: string): string {
    const fileExtension = fileName.split('.').pop().toLowerCase();
    return fileExtension;
  }


  private getMimeType(fileExtension: string): string {
    // Map the file extension to the corresponding MIME type
    const mimeTypeMap = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      xls: 'application/vnd.ms-excel',
      csv: 'text/csv'
    };

    return mimeTypeMap[fileExtension];
  }


  isValidFileFormat(file: File): boolean {
    const allowedMimePrefixes = [
      'image/' // all image types (jpg, png, heic, webp, etc.)
    ];

    const allowedExactMimeTypes = [
      // PDF
      'application/pdf',

      // Word
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

      // Excel
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

      // CSV (different browsers report it differently)
      'text/csv',
      'application/csv',
      'text/plain'
    ];

    // 1️⃣ Primary check (modern browsers)
    if (file.type) {
      if (allowedMimePrefixes.some(prefix => file.type.startsWith(prefix))) {
        return true;
      }

      if (allowedExactMimeTypes.includes(file.type)) {
        return true;
      }
    }

    // 2️⃣ Fallback (Safari / iOS / older browsers)
    const allowedExtensions = [
      // images
      'jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif',

      // documents
      'pdf', 'doc', 'docx',

      // excel
      'xls', 'xlsx',

      // csv
      'csv'
    ];

    const extension = file.name.split('.').pop()?.toLowerCase();
    return !!extension && allowedExtensions.includes(extension);
  }


  uploadFiles() {
    //const formData = new FormData();

    //for (let i = 0; i < this.validFiles.length; i++) {
    //  formData.append('files[]', this.validFiles[i]);
    //}

    ////console.log(this.fileData)
    //this.http.post('https://example.com/upload', formData).subscribe(
    //  (response) => {
    //    //console.log('Upload successful', response);
    //  },
    //  (error) => {
    //    //console.log('Upload error', error);
    //  }
    //);
  }


  // Check if the first five fields are valid
  areFirstFiveFieldsValid(firstFiveFields: any): boolean {


    for (const fieldName of firstFiveFields) {
      const fieldControl = this.icdForm.get(fieldName);
      if (fieldControl && fieldControl.invalid) {
        return false;
      }
    }

    return true;
  }

  // Example implementation of getErrorMessage function
  getErrorMessage(fieldName: string): string {
    const control = this.icdForm.get(fieldName);

    if (control?.errors) {
      if (control.errors.required) {
        return 'This field is required.';
      }
      if (control.errors.invalidHtml) {
        return 'HTML or script content is not allowed.';
      }

      // Add additional error messages for specific validation rules as needed
    }

    return 'Invalid field.';
  }
   
  saveData(isSubmitted: boolean) {
    //debugger;
    this.isLoading = true;
    this.btnDisplay = false;
    this.alertService.startLoadingMessage('', 'Data Submitting...');

    // Get the form values as an object
    const formValues = this.icdForm.getRawValue();



    // Set the properties of the ICD instance with the form values
    this.icd.US_or_CA = formValues.US_or_CA;
    
    
    this.icd.State_UI_ID = formValues.State_UI_ID;
    this.icd.First_Date_New_Address = this.toSfDate(formValues.First_Date_New_Address);
    
    this.icd.New_Address = formValues.New_Address;
    this.icd.Company_Address2 = formValues.Company_Address2;
    this.icd.Company_City = formValues.Company_City;
    this.icd.Company_Postal_Code = formValues.Company_Postal_Code;
    this.icd.Company_Office_Phone = formValues.Company_Office_Phone;
    this.icd.Company_Country = formValues.Company_Country;
    this.icd.Company_State = formValues.Company_State;
    this.icd.Company_Province = formValues.Company_Province;

    //this.icd.Owner_Last_Name = formValues.ICD_Owner_Name;    
    this.icd.Owner_Office_Phone = formValues.Owner_Mobile_Phone;
    this.icd.Sales_tax_perc = formValues.Sales_tax_perc;
    this.icd.New_Location_out_state = formValues.New_Location_out_state;
    this.icd.Is_storage_location = formValues.Is_storage_location;
    this.icd.Main_or_Satellite = formValues.Main_or_Satellite;
    this.icd.New_DBA_Name = formValues.New_DBA_Name;
    this.icd.IsPreferredDBA = formValues.isPreferredDBA;
    this.icd.PreferredDBAName = formValues.preferredDBAName;

    if (this.icd.US_or_CA == "US") {
      const campaignsString = this.US_Campaigns_selectedItems.join(', ');
      const retailsString = this.US_Retails_selectedItems.join(', ');
      this.icd.Campaigns = campaignsString;
      this.icd.Retailers = retailsString;

      const attachFields = [
        'Node_Form',
        'Attach_Incorporation',
        'Attach_DBA_Doc', 'Attach_Renter_Insurance', 'Extra_Provincial_License', 'Workers_Compensation','Attach_US_Certificate_of_Insurance'
      
      ];

      for (const field of attachFields) {
        const filteredBase64Array = this.fileData
          .filter(file => file.attachment_Type === field)
          .map(file => file.attachment_Base64);

        const commaSeparatedBase64 = filteredBase64Array.join('$$$');

        this.icd[field] = commaSeparatedBase64;
      }


    }
    else {

      const campaignsString = this.Canada_Campaigns_selectedItems.join(', ');
      const retailsString = this.Canada_Retails_selectedItems.join(', ');
      this.icd.Campaigns = campaignsString;
      this.icd.Retailers = retailsString;

      const attachCanadaFields = [
        'Node_Form',
        'Attach_Incorporation',
        'Attach_DBA_Doc', 'Attach_Renter_Insurance','Extra_Provincial_License'
      
      ];

      for (const field of attachCanadaFields) {
        const filteredBase64Array = this.fileData
          .filter(file => file.attachment_Type === field)
          .map(file => file.attachment_Base64);

        const commaSeparatedBase64 = filteredBase64Array.join('$$$');

        this.icd[field] = commaSeparatedBase64;
      }



    }


    if (formValues.isInsuranceRequired == "true") {
      this.icd.isInsuranceRequired = true;
    }
    else {
      this.icd.isInsuranceRequired = false;
    }

    this.icd.Male_Emp = formValues.Male_Emp;
    this.icd.FeMale_Emp = formValues.FeMale_Emp;
    this.icd.Disability_Form = formValues.Disability_Form;

    // FR4/FR7: send only successfully-staged files (carrying FileId for the confirm/move call)
    // plus their metadata/content for DB retention. Errored/in-flight files are excluded.
    this.icd.Attachments = this.fileData.filter(f => f.status === 'uploaded');
    this.icd.TestCampaignNotListed = formValues.TestCampaignNotListed;
    this.icd.IsSubmitted = isSubmitted;
    ////console.log(this.icd);
    this.SaveDatatoDB();

  }

  SaveDatatoDB() {
    Swal.fire({
      title: 'Submitting data...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    // Create a new instance of the ICD class
    let responseAPI = new ResponseAPI();
    this.sfDataService.CreateAddLoc(this.icd)
      .subscribe(
        data => {
          Swal.close();
          //responseAPI = data;
          // Assign the received data to the responseAPI object
          responseAPI = data;
          if (responseAPI.isSuccess && !responseAPI.isValidationError) {
            //location.reload();

            //setTimeout(() => {
            this.alertService.showMessage('ICD', `Data Saved Successfully`, MessageSeverity.success);
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.idn = responseAPI.data;

            
              this.ShowSuccesspopup(this.isInsuranceRequired);
            
            

            //}, 200);
          }
          else {
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.btnDisplay = true;

            // FR6: surface the real server message (e.g. document move/confirm failure) rather
            // than a generic error, and guard against a missing ErrorList payload.
            const serverMessage = responseAPI.description
              || (responseAPI.data && responseAPI.data.error && responseAPI.data.error.message)
              || 'An error occurred while saving data. Please try again.';
            const errorCode = (responseAPI.data && responseAPI.data.error && responseAPI.data.error.errorCode) || '';

            this.alertService.showMessage('ICD', 'Submission failed', MessageSeverity.error);
            this.alertService.showStickyMessage('Unable to store data', serverMessage, MessageSeverity.error, errorCode);
          }

        },
        error => {
          Swal.close();
          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });

  }

  numberValidator(control: FormControl) {
    const isValid = /^\d+$/.test(control.value);
    return isValid ? null : { 'invalidNumber': true };
  }

  BindDropdowns() {
    //debugger;
    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');

    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    this.sfDataService.getMasterConfigs("US_State,Canada_Province,US_Retails,US_Campaigns,Canada_Retails,Canada_Campaigns,DeliveryTime")
      .subscribe(
        data => {
          ////console.log(data);
          //debugger;
          this.masterConfig = data;
          this.ddlUSStates = this.masterConfig.filter(a => a.type == "US_State");
          this.ddlCAProvinence = this.masterConfig.filter(a => a.type == "Canada_Province");
          //this.Canada_campaignData = this.masterConfig.filter(a => a.type == "Canada_Campaigns");
          //   this.Canada_retailsData = this.masterConfig.filter(a => a.type == "Canada_Retails");
          // this.US_campaignData = this.masterConfig.filter(a => a.type == "US_Campaigns");
          //  this.US_retailsData = this.masterConfig.filter(a => a.type == "US_Retails");
          this.ddlBest_Delivery_Time = this.masterConfig.filter(a => a.type == "DeliveryTime");
          this.alertService.stopLoadingMessage();
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });

    this.sfDataService.getCMReports().subscribe(resp => {
      ////console.log(resp);

      let res: any;

      res = resp;

      this.Canada_campaignData = res.filter(a => a.country == "CAN" && a.status != "Ended" && a.dueDiligenceRequired != "Yes")
        .sort((a, b) => a.campaignName.localeCompare(b.campaignName));
      this.US_campaignData = res.filter(a => a.country == "USA" && a.status != "Ended" && a.dueDiligenceRequired != "Yes")
        .sort((a, b) => a.campaignName.localeCompare(b.campaignName));

      var TestCampaign = {
        attributes: null,
        backgroundCheck: "Yes",
        campaignName: "TestCampaign(NotListed)",
        channel: "TestCampaign(NotListed)",
        country: "USA",
        drugScreen: "No",
        id: "a1122334455",
        legacyCampaignInfo: null,
        name: "TestCampaign(NotListed)",
        status: "Production",
        supplementalBackground: null
      }

      var TestCampaign_na = {
        attributes: null,
        backgroundCheck: "Yes",
        campaignName: "N/A",
        channel: "N/A",
        country: "USA",
        drugScreen: "No",
        id: "a112233445566",
        legacyCampaignInfo: null,
        name: "N/A",
        status: "Production",
        supplementalBackground: null
      }
     

      this.US_campaignData.push(TestCampaign);

      this.Canada_campaignData.push(TestCampaign_na);
      this.US_campaignData.push(TestCampaign_na);


      this.Canada_campaignData_DD = res.filter(a => a.country == "CAN" && a.status != "Ended" && a.dueDiligenceRequired == "Yes")
        .sort((a, b) => a.campaignName.localeCompare(b.campaignName));;
      this.US_campaignData_DD = res.filter(a => a.country == "USA" && a.status != "Ended" && a.dueDiligenceRequired == "Yes")
        .sort((a, b) => a.campaignName.localeCompare(b.campaignName));
      ////console.log(this.US_campaignData)

      //      //console.log(this.Canada_campaignData)
    });


    this.sfDataService.getRetails().subscribe(resp => {
      ////console.log(resp);

      let res: any;

      res = resp;

      var testretail = {
        endDate: null,
        id: "a163s00000MRT5YAAX123",
        isDeleted: "false",
        name: "N/A",
        ownerId: "0051I000002BtCTQA0123",
        startDate: "2010-01-01"
      }

      this.Canada_retailsData = res.filter(a => a.isDeleted == "false");
      this.US_retailsData = res.filter(a => a.isDeleted == "false");
      
      this.US_retailsData.push(testretail);
      this.Canada_retailsData.push(testretail);
      ////console.log(this.US_campaignData)

      ////console.log(this.Canada_campaignData)
    });

    this.sfDataService.getAddInfoDDs().subscribe(resp => {
      ////console.log(resp);

      let res: any;

      res = resp;


      this.NC_namesData = res.ncNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));
      ;
      this.RC_namesData = res.rcNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));;
      this.PO_namesData = res.poNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));;
      
      ////console.log(this.NC_namesData)

      ////console.log(this.Canada_campaignData)
    });

    

  }

  onCheckboxPo(selectElement) {

    if (selectElement != null) {
      const selectedIndex = this.PO_namesData.filter(item => item.ownerName == selectElement);


      if (selectedIndex.length >= 0) {
        this.icdForm.controls['Promoting_Owner_Company'].setValue(selectedIndex[0].name);
      } else {
        this.icdForm.controls['Promoting_Owner_Company'].setValue('');
      }

    }


  }


  onCheckboxNC(selectElement) {

    if (selectElement != null) {
      const selectedIndex = this.NC_namesData.filter(item => item.ownerName == selectElement);


      if (selectedIndex.length >= 0) {
        this.icdForm.controls['National_Consultant_Company'].setValue(selectedIndex[0].name);
      } else {
        this.icdForm.controls['National_Consultant_Company'].setValue('');
      }

    }


  }


  onCheckboxRC(selectElement) {

    if (selectElement != null) {
      const selectedIndex = this.RC_namesData.filter(item => item.ownerName == selectElement);


      if (selectedIndex.length >= 0) {
        this.icdForm.controls['Regional_Consultant_Company'].setValue(selectedIndex[0].name);
      } else {
        this.icdForm.controls['Regional_Consultant_Company'].setValue('');
      }

    }


  }

  private mapDataToICD(data: any) {
    if (data == null) {

      this.icdForm.disable();
      this.alertService.showMessage('ICD', `This Case is not assigned to view`, MessageSeverity.error);
      this.alertService.startLoadingMessage('', 'This Case is not assigned to view');
      this.alertService.showStickyMessage('ICD', 'This Case is not assigned to view', MessageSeverity.error, "");
      this.btnDisplay = false;
      this.isCheckboxesDisabled = true;
      return;
    }
    //debugger;
    this.icdForm.controls['US_or_CA'].setValue(data.uS_or_CA);
    this.onCountryChange();
    this.icdForm.controls['Full_Legal_Company_Name'].setValue(data.full_Legal_Company_Name);
    this.icd.Full_Legal_Company_Name = data.full_Legal_Company_Name;
    this.icd.Owner_First_Name = data.owner_First_Name;
    this.icd.Owner_Last_Name = data.owner_Last_Name;

    this.icd.Owner_Preferred_First_Name = data.owner_Preferred_First_Name;
    this.icd.Owner_Preferred_Last_Name = data.owner_Preferred_Last_Name;

    this.icd.Owner_Name = data.owner_Name;
    this.icdForm.controls['ICD_Owner_Name'].setValue(data.owner_Name);
    this.icdForm.controls['Tax_ID'].setValue(data.tax_ID);
    this.icd.Tax_ID = data.tax_ID;
    this.icdForm.controls['State_UI_ID'].setValue(data.uiD_Number);
    this.icdForm.controls['First_Date_New_Address'].setValue(this.toDisplayDate(data.first_Day_at_New_Address));
    this.icdForm.controls['HUB_Manager_Contact_Name'].setValue(data.huB_Manager_Contact_Name);

    this.icdForm.controls['Sales_tax_perc'].setValue(data.new_State_Sales_Tax);
    //this.icdForm.controls['New_Location_out_state'].setValue('false');
    //this.icdForm.controls['Is_storage_location'].setValue('false');
        

   // this.icdForm.controls['New_Address'].setValue(data.new_Location);
    //this.icdForm.controls['Company_Address2'].setValue(data.homeAddress2);
    //this.icdForm.controls['Company_City'].setValue(data.owner_City);
    //this.icdForm.controls['Company_Country'].setValue(data.homeCountry);
    //this.icdForm.controls['Company_Postal_Code'].setValue(data.zipCode);
    this.icdForm.controls['Company_Office_Phone'].setValue(data.homePhone);   
    //this.icdForm.controls['Company_State'].setValue(data.state);
    //this.icdForm.controls['Company_Province'].setValue(data.state);
    this.icdForm.controls['Owner_Mobile_Phone'].setValue(data.owner_Office_Phone);
    ////console.log(data);

    this.icdForm.controls['Promoting_Owner'].setValue(data.promotingOwner);
    this.icdForm.controls['Promoting_Owner_Company'].setValue(data.promotingOwnerCompany);
    this.icdForm.controls['Regional_Consultant'].setValue(data.regionalConsultant);
    this.icdForm.controls['Regional_Consultant_Company'].setValue(data.regionalConsultantCompany);
    this.icdForm.controls['National_Consultant'].setValue(data.nationalConsultant);
    this.icdForm.controls['National_Consultant_Company'].setValue(data.nationalConsultantCompany);

    this.icd.PromotingOwner = data.promotingOwner;
    this.icd.PromotingOwnerCompany = data.promotingOwnerCompany;
    this.icd.RegionalConsultant = data.regionalConsultant;
    this.icd.RegionalConsultantCompany = data.regionalConsultantCompany;
    this.icd.NationalConsultant = data.nationalConsultant;
    this.icd.NationalConsultantCompany = data.nationalConsultantCompany;

    //if (data.uS_or_CA == 'US') {
    //  if (data.campaigns != null) {
    //    this.US_Campaigns_selectedItems = data.campaigns.split(',').map((item) => item.trim());
    //  }
    //  if (data.retailers != null) {
    //    this.US_Retails_selectedItems = data.retailers.split(',').map((item) => item.trim());
    //  }
      
    //}
    //else {
    //  if (data.campaigns != null) {
    //    this.Canada_Campaigns_selectedItems = data.campaigns.split(',').map((item) => item.trim());
    //  }
    //  if (data.retailers != null) {
    //    this.Canada_Retails_selectedItems = data.retailers.split(',').map((item) => item.trim());
    //  }
      
    //}

    ////console.log(data);
    this.icd.AccountID = data.accountID;

    this.icd.HUB_Manager_Contact = data.huB_Manager_Contact;
    this.icd.HUB_Manager_Contact_Name = data.huB_Manager_Contact_Name;
    this.icd.HUB_Manager_Contact_Number = data.huB_Manager_Contact_Number;
    this.icd.HUB_Manager_Contact_Email = data.huB_Manager_Contact_Email;
    this.icd.HUB_Assistance_Email = data.huB_Assistance_Email;
    this.icd.CaseID = data.caseID;
    this.icd.ContactID = data.contactID;
    if (data.attachments != null) {
      for (let i = 0; i < data.attachments.length; i++) {
        const file = data.attachments[i];

        this.fileData.push({ attachment_FileName: file.attachment_FileName, attachment_Base64: file.attachment_Base64, attachment_Type: file.attachment_Type });
      }

    }


    //if (data.first_Day_at_New_Address != null) {
    //  this.icd.First_Date_New_Address = data.first_Day_at_New_Address;
    //  this.icdForm.disable();
    //  this.alertService.showMessage('ICD', `Step 3 Already Completed`, MessageSeverity.success);
    //  this.alertService.startLoadingMessage('', 'Step 3 Already Completed');
    //  this.alertService.showStickyMessage('ICD', 'Step 3 Already Completed', MessageSeverity.error, "");
    //  this.btnDisplay = false;
    //  this.isCheckboxesDisabled = true;
    //}
   
    this.dataEmitter.emit(this.datad);


  }

  BindData(id: string) {
    //debugger;

    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');
    if (this.f != null && this.d != null) {
      this.sfDataService.getICDStep3byAcc(id)
        .subscribe(
          data => {
            //console.log(data);
            //debugger;

            this.mapDataToICD(data);
            ////console.log(data);


            this.alertService.stopLoadingMessage();
          },
          error => {

            this.alertService.stopLoadingMessage();

            if (Utilities.checkNoNetwork(error)) {
              this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
              this.offerAlternateHost();
            } else {
              const errorMessage = Utilities.getHttpResponseMessage(error);

              if (errorMessage) {
                this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
              } else {
                this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
              }
            }

            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
}
    else {
      this.sfDataService.getICDStep3(id)
        .subscribe(
          data => {
            //console.log(data);
            //debugger;

            this.mapDataToICD(data);
            ////console.log(data);


            this.alertService.stopLoadingMessage();
          },
          error => {

            this.alertService.stopLoadingMessage();

            if (Utilities.checkNoNetwork(error)) {
              this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
              this.offerAlternateHost();
            } else {
              const errorMessage = Utilities.getHttpResponseMessage(error);

              if (errorMessage) {
                this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
              } else {
                this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
              }
            }

            setTimeout(() => {
              this.isLoading = false;
            }, 500);
          });
}
    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
   
  }

  mapLoginErrorMessage(error: string) {

    if (error === 'invalid_username_or_password') {
      return 'Invalid username or password';
    }

    if (error === 'invalid_grant') {
      return 'This account has been disabled';
    }

    return error;
  }

  offerAlternateHost() {

    if (Utilities.checkIsLocalHost(location.origin) && Utilities.checkIsLocalHost(this.configurations.baseUrl)) {
      this.alertService.showDialog('Dear Developer!\nIt appears your backend Web API service is not running...\n' +
        'Would you want to temporarily switch to the online Demo API below?(Or specify another)',
        DialogType.prompt,
        (value: string) => {
          this.configurations.baseUrl = value;
          this.alertService.showStickyMessage('API Changed!', 'The target Web API has been changed to: ' + value, MessageSeverity.warn);
        },
        null,
        null,
        null,
        this.configurations.fallbackBaseUrl);
    }
  }

  trimFormValues() {

    // Avoid setting value on file inputs. Skip controls that look like file attachments
    // (names starting with "Attach_") or whose value is a File/FileList/object.
    Object.keys(this.icdForm.controls).forEach(key => {
      // Skip known file-type controls
      if (/^Attach_/i.test(key) || /Attach/i.test(key)) {
        return;
      }

      const control = this.icdForm.get(key);
      if (!control) {
        return;
      }

      const val = control.value;

      // Skip File / FileList / object values to avoid InvalidStateError
      if (val instanceof File || (typeof FileList !== 'undefined' && val instanceof FileList) || typeof val === 'object') {
        return;
      }

      if (typeof val === 'string') {
        try {
          control.setValue(val.trim());
        } catch (e) {
          // don't break form processing on single control error
          console.warn(`trimFormValues: skipped trimming control '${key}' due to error`, e);
        }
      }
    });
  }

  noHtmlTagsValidator(control: any) {

    if (!control.value) {
      return null;
    }

    const value = control.value.toString().trim();

    const htmlPattern =
      /(<[^>]+>|&lt;|&gt;|javascript:|onerror=|onload=|<script|<\/script>)/gi;

    if (htmlPattern.test(value)) {
      return { invalidHtml: true };
    }

    return null;
  }

  reset() {
    this.formResetToggle = false;

    setTimeout(() => {
      this.formResetToggle = true;
    });
  }



  // Helper: keep items where closed date is null/empty OR within `days` days from now
  private filterRecentRecords(items: any[], days: number): any[] {
    if (!items || !Array.isArray(items)) return [];
    const now = Date.now();
    return items.filter(item => {
      // prefer Salesforce field closed_Date__c
      const raw = item?.closed_Date__c ?? item?.closedDate ?? item?.closed_date ?? item?.Closed_Date__c ?? item?.ClosedDate ?? null;
      if (!raw) return true; // include when no closed date
      const parsed = Date.parse(String(raw));
      if (!isNaN(parsed)) {
        const diffDays = (now - parsed) / (1000 * 60 * 60 * 24);
        return diffDays <= days;
      }
      // try take date portion before T
      const idx = String(raw).indexOf('T');
      if (idx > 0) {
        const dateOnly = String(raw).substring(0, idx);
        const p2 = Date.parse(dateOnly);
        if (!isNaN(p2)) {
          const diffDays = (now - p2) / (1000 * 60 * 60 * 24);
          return diffDays <= days;
        }
      }
      // if cannot parse, exclude
      return false;
    });
  }

  getCharacterCount(controlName: string): number {
    return (this.icdForm.get(controlName)?.value || '').length;
  }

  getMaxLength(controlName: string): number {
    return this.fieldMaxLengths[controlName] || 0;
  }

  get hasDocVerificationBlock(): boolean {
    return Object.values(this.verificationState).some(s => s === 'verifying' || s === 'fail');
  }

  private triggerDocumentVerification(controlName: string): void {
    const docType = this.VERIFIED_DOC_TYPES[controlName];
    if (!docType) return;

    const fileEntry = this.fileData.find(f => f.attachment_Type === controlName);
    if (!fileEntry) return;

    this.verificationState[controlName] = 'verifying';
    this.verificationIssues[controlName] = [];

    const formValues = this.icdForm.getRawValue();
    const mimeType = this.getMimeType(this.getFileExtension(fileEntry.attachment_FileName));

    const body = {
      documentType: docType,
      base64Content: fileEntry.attachment_Base64,
      mimeType,
      companyName: formValues.Full_Legal_Company_Name || '',
      taxId: formValues.Tax_ID || '',
      stateOfIncorporation: '',
      provinceOfIncorporation: '',
      dateOfIncorporation: '',
    };

    this.sfDataService.verifyDocument(body).subscribe({
      next: (result: any) => {
        if (result.overallPass) {
          this.verificationState[controlName] = result.issues && result.issues.length > 0 ? 'warn' : 'pass';
        } else {
          this.verificationState[controlName] = 'warn';
        }
        this.verificationIssues[controlName] = result.issues || [];
      },
      error: () => {
        this.verificationState[controlName] = 'warn';
        this.verificationIssues[controlName] = ['Document verification unavailable — please verify manually.'];
      }
    });
  }

  buildFormSnapshot(): Record<string, string> {
    const raw = this.icdForm.getRawValue();
    const snap: Record<string, string> = {};
    Object.keys(raw).forEach(k => {
      const ctrl = this.icdForm.get(k);
      if (ctrl && ctrl.disabled) { return; } // skip disabled/read-only fields — user cannot act on the advisory
      const v = raw[k];
      if (v !== null && v !== undefined && v !== '' && typeof v !== 'object') {
        snap[k] = String(v);
      }
    });
    return snap;
  }

  runPreSubmitReview(): void {
    this.preSubmitLoading = true;
    this.preSubmitIssues = [];
    const snapshot = this.buildFormSnapshot();
    this.agentService.getPreSubmitReview(snapshot).pipe(
      catchError(() => of({ issues: [] }))
    ).subscribe(res => {
      this.preSubmitIssues = [...(res?.issues ?? []), ...this.buildVerificationIssues()];
      this.preSubmitLoading = false;
    });
  }

  private buildVerificationIssues(): PreSubmitIssue[] {
    const docLabels: { [key: string]: string } = {
      Attach_Incorporation: 'Articles of Incorporation',
      Attach_US_Certificate_of_Insurance: 'Certificate of Insurance',
    };
    const issues: PreSubmitIssue[] = [];
    Object.entries(this.verificationState).forEach(([controlName, state]) => {
      if (state !== 'fail' && state !== 'warn') return;
      const label = docLabels[controlName] ?? controlName;
      const fieldIssues = this.verificationIssues[controlName] ?? [];
      if (fieldIssues.length > 0) {
        fieldIssues.forEach(issue => issues.push({
          fieldName: controlName, label,
          issue, severity: 'warning', suggestedFix: null, canAutoFix: false
        }));
      } else {
        issues.push({
          fieldName: controlName, label,
          issue: state === 'fail' ? 'Document verification failed' : 'Document accepted with notes',
          severity: 'warning', suggestedFix: null, canAutoFix: false
        });
      }
    });
    return issues;
  }

  onPreSubmitDismiss(): void { this.showPreSubmitReview = false; }

  onPreSubmitDoSubmit(): void {
    this.showPreSubmitReview = false;
    this.saveData(true);
  }

  onPreSubmitRecheck(): void { this.runPreSubmitReview(); }

  onPreSubmitAutoFix(fix: { fieldName: string; suggestedFix: string }): void {
    const ctrl = this.icdForm.get(fix.fieldName);
    if (ctrl) { ctrl.setValue(fix.suggestedFix); ctrl.markAsDirty(); }
  }

  onPreSubmitNavigate(fieldName: string): void {
    const el = document.getElementById(fieldName) || document.querySelector(`[formcontrolname="${fieldName}"]`);
    if (el) (el as HTMLElement).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }


}


